import {
    getObjects,
    createObjects,
    updateObjects,
    deleteObjects,
} from './../api/webApplicationApi';
import { v4 as uuidv4 } from 'uuid';
import { AirCurtain } from './airCurtain';

const objectType = 'airCurtainGroup';

export class AirCurtainGroup {
    private _saveMethod = createObjects;
    private _object: omAirCurtainGroup;
    private _lastError: Error;

    public constructor(airCurtainGroupID: string) {
        this._object = {
            airCurtainGroupID: airCurtainGroupID,
            accountID: undefined,
            name: undefined,
            parentObjectType: undefined,
            parentObjectID: undefined,
            airCurtains: [],
        };
    }

    public static createNew(): AirCurtainGroup {
        return new AirCurtainGroup(uuidv4());
    }

    public static createFromObject(airCurtainGroup: omAirCurtainGroup) {
        const obj = new AirCurtainGroup(airCurtainGroup.airCurtainGroupID);
        obj._object = airCurtainGroup;
        obj._saveMethod = updateObjects;
        return obj;
    }

    public async load(): Promise<boolean> {
        const getObject: GetRequest = {
            objectType: objectType,
            keys: [this._object.airCurtainGroupID],
        };
        this._lastError = undefined;

        try {
            const response = await getObjects([getObject]);
            if (
                response &&
                response.length > 0 &&
                response[0].objects &&
                response[0].objects.length == 1
            ) {
                this._saveMethod = updateObjects;
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('air curtain group not found');
                return false;
            }
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async save(): Promise<boolean> {
        const saveObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;

        if (this._object.name == undefined) {
            this._lastError = new Error('Name is undefined');
            return false;
        }
        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID is undefined');
            return false;
        }
        if (this._object.parentObjectType == undefined) {
            this._lastError = new Error('Parent Group Type is undefined');
            return false;
        }
        if (this._object.parentObjectID == undefined) {
            this._lastError = new Error('Parent Group ID is undefined');
            return false;
        }
        try {
            const response = await this._saveMethod([saveObject]);
            if (response) {
                this._saveMethod = updateObjects;
            } else {
                this._lastError = new Error('unknown server error');
            }
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async delete(): Promise<boolean> {
        const deleteObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;
        try {
            const response = await deleteObjects([deleteObject]);
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public get lastError(): Error {
        return this._lastError;
    }

    public get airCurtainGroupID(): string {
        return this._object.airCurtainGroupID;
    }

    public get accountID(): string {
        return this._object.accountID;
    }

    public set accountID(accountID: string) {
        this._object.accountID = accountID;
    }

    public get name(): string {
        return this._object.name;
    }

    public set name(name: string) {
        this._object.name = name;
    }

    public get parentObjectType(): string {
        return this._object.parentObjectType;
    }

    public set parentObjectType(parentObjectType: string) {
        this._object.parentObjectType = parentObjectType;
    }

    public get parentObjectID(): string {
        return this._object.parentObjectID;
    }

    public set parentObjectID(parentObjectID: string) {
        this._object.parentObjectID = parentObjectID;
    }

    public get airCurtains(): string[] {
        return this._object.airCurtains;
    }

    public addAirCurtain(airCurtain: AirCurtain): void {
        if (this._object.airCurtains.includes(airCurtain.airCurtainID)) return;
        this._object.airCurtains.push(airCurtain.airCurtainID);
    }

    public deleteAirCurtain(airCurtain: AirCurtain): void {
        const index = this._object.airCurtains.indexOf(airCurtain.airCurtainID);
        if (index > -1) {
            this._object.airCurtains.splice(index, 1);
        }
    }
}
